export const highlightKeywords = (text, keywords) => {
    if (!text || keywords.length === 0) return text;
  
    const pattern = new RegExp(`(${keywords.join('|')})`, 'gi');
  
    return text.split(pattern).map((part, i) =>
      keywords.some(k => k.toLowerCase() === part.toLowerCase()) ? (
        <span key={i} className="highlight">{part}</span>
      ) : (
        part
      )
    );
  };